let webPIsSupported: boolean = false;

const WEBP_BLACKLIST: string[] = [
    'resource/graphics/particles',
    'resource/graphics/shares',
    'resource/graphics/level_backgrounds',
    'resource/graphics/other',
    'resource/graphics/messages',

    // This file gets 200kb bigger due to strong transparency effects
    // so we'll just load the png.
    // todo: come up with better system than a blacklist
    'resource/graphics/sprite_sheets/LuckyTurnips',
];

export function isWebPSupported(): boolean {
    return webPIsSupported;
}

const webPTestImages = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha:
        'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation:
        'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
};

type WebPFeature = keyof typeof webPTestImages;

/**
 * Check all required WebP features are supported for SOFAs use-cases.
 */
export async function checkWebpSupport() {
    const features: WebPFeature[] = ['alpha', 'lossless', 'lossy'];
    try {
        await Promise.all(features.map(checkWebpFeatureSupport));
        webPIsSupported = true;
        console.log('WebP supported');
    } catch {
        console.log('WebP unsupported');
    }
}

/**
 * Check for individual WebP feature support. This is the recommended approach.
 * @see https://developers.google.com/speed/webp/faq#how_can_i_detect_browser_support_for_webp
 * @param feature
 */
async function checkWebpFeatureSupport(feature: WebPFeature) {
    return new Promise<void>((resolve, reject) => {
        const img = new Image();
        img.onload = function() {
            const result = img.width > 0 && img.height > 0;
            if (result) {
                resolve();
            } else {
                reject();
            }
        };
        img.onerror = function() {
            reject();
        };
        img.src = 'data:image/webp;base64,' + webPTestImages[feature];
    });
}

export function shouldLoadAsWebP(
    resource?: PIXI.loaders.Resource | null,
    optExtension?: string,
    optName?: string,
    optUrl?: string
): boolean {
    return (
        // is PNG
        (resource?.extension || optExtension) === 'png' &&
        // is an image from PIXI loader
        (((resource?.name || optName).indexOf('_image') >= 0 &&
            (resource?.name || optName).indexOf('_image') === (resource?.name || optName).length - '_image'.length) ||
            (optUrl && optUrl.indexOf('/dragonbones/') !== -1)) &&
        // is not on the blacklist
        WEBP_BLACKLIST.findIndex(e => (resource?.url || optUrl).indexOf(e) !== -1) === -1
    );
}
